"use client";
import { motion } from "motion/react";
import { Link as RouterLink } from "react-router-dom";

const transition = {
  type: "spring",
  mass: 0.5,
  damping: 11.5,
  stiffness: 100,
  restDelta: 0.001,
  restSpeed: 0.001,
};

export const MenuItem = ({
  setActive,
  active,
  item,
  children,
  className = "",
}) => {
  return (
    <div onMouseEnter={() => setActive(item)} className="relative">
      <motion.p
        transition={{ duration: 0.3 }}
        className={`cursor-pointer text-black hover:opacity-[0.9] dark:text-white ${className}`}
      >
        {item}
      </motion.p>
      {active !== null && (
        <motion.div
          initial={{ opacity: 0, scale: 0.85, y: 10 }}
          animate={{ opacity: 1, scale: 1, y: 0 }}
          transition={transition}
        >
          {active === item && (
            <div className="absolute top-[calc(100%_+_0.25rem)] left-1/2 transform -translate-x-1/2 pt-1">
              <motion.div
                transition={transition}
                layoutId="active"
                className="bg-background/80 dark:bg-black/80 backdrop-blur-sm rounded-xl overflow-hidden shadow-sm"
              >
                <motion.div layout className="w-max h-full p-2">
                  {children}
                </motion.div>
              </motion.div>
            </div>
          )}
        </motion.div>
      )}
    </div>
  );
};

export const Menu = ({ setActive, children, className = "" }) => {
  return (
    <nav
      // resets the state
      onMouseLeave={() => setActive(null)}
      className={`relative rounded-full flex justify-center space-x-4 px-4 py-2 ${className}`}
    >
      {children}
    </nav>
  );
};

export const ProductItem = ({ title, description, href, src }) => {
  return (
    <RouterLink to={href} className="flex space-x-2">
      <img
        src={src}
        alt={title}
        className="w-[140px] h-[70px] object-cover shrink-0 rounded-md shadow-2xl"
      />
      <div>
        <h4 className="text-xl font-bold mb-1 text-black dark:text-white">
          {title}
        </h4>
        <p className="text-neutral-700 text-sm max-w-[10rem] dark:text-neutral-300">
          {description}
        </p>
      </div>
    </RouterLink>
  );
};

export const HoveredLink = ({ children, href, ...rest }) => {
  // Check if it's an external link
  const isExternal =
    href?.startsWith("http") ||
    href?.startsWith("mailto:") ||
    href?.startsWith("tel:");

  if (isExternal) {
    return (
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        className="text-neutral-700 dark:text-neutral-200 hover:text-black"
        {...rest}
      >
        {children}
      </a>
    );
  }

  return (
    <RouterLink
      to={href || "#"}
      className="text-neutral-700 dark:text-neutral-200 hover:text-black"
      {...rest}
    >
      {children}
    </RouterLink>
  );
};
